import trekzyLogo from '../../assets/images/trekzy-logo2.svg'
import toursprivados from '../../assets/images/toursprivadosbytrekzy-logo-white.png'
import Header2 from '../Header2'
import Footer2 from '../Footer2'
import { useTranslation } from 'react-i18next';

const CheckoutLayout = ({ children }) => {
    const { t } = useTranslation('paths');
    const { i18n } = useTranslation();
    return (
        <>
            <Header2 logoImgSource={i18n.language == 'es' ? toursprivados : trekzyLogo} logoWidth={i18n.language == 'es' ? '15rem' : '8rem'} />
            {children}
            <Footer2 />
        </>
    )
}

export default CheckoutLayout
